module.exports = __webpack_public_path__ + "static/campaign-progress-b4d8d9359734c72bd21031c78354151d.jpg";